var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTabExpand(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2815_10363)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 2,
    width: 30,
    height: 30,
    rx: 4,
    transform: "rotate(90 34 2)",
    fill: "#F9F1DD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.75,
    y: 2.25,
    width: 29.5,
    height: 29.5,
    rx: 3.75,
    transform: "rotate(90 33.75 2.25)",
    stroke: "#FFDC8A",
    strokeWidth: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9792 18.475C21.0914 16.4409 23.1587 14.4491 25.228 12.4596C25.3741 12.3197 25.5232 12.1666 25.6943 12.081C26.1042 11.8772 26.6059 12.0737 26.8416 12.4945C27.0899 12.9383 27.0523 13.4772 26.6862 13.8606C26.172 14.3996 25.6286 14.9012 25.0945 15.4161C23.2943 17.1523 21.494 18.8898 19.6906 20.6225C19.1774 21.1156 18.7915 21.1265 18.295 20.6502C16.0107 18.4557 13.7223 16.2661 11.46 14.0415C11.2138 13.7992 11.0031 13.3446 11 12.9853C10.9979 12.6875 11.2806 12.2076 11.5174 12.1304C11.8303 12.0279 12.309 12.1063 12.5635 12.3354C13.8235 13.47 15.0324 14.6793 16.2611 15.861C17.1539 16.7207 18.0478 17.5792 18.9792 18.475Z",
    fill: "#DEA829"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2815_10363",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2815_10363"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2815_10363",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabExpand);
export default __webpack_public_path__ + "static/media/tab_expand.0abdeb3f67268b00d1cbe6c4862fb542.svg";
export { ForwardRef as ReactComponent };